(() => {
  let lenis;
  let animationFrame;

  const updateHeroParallax = () => {
    const hero = document.querySelector('[data-sembonia-hero]');
    if (!hero) return;

    const rect = hero.getBoundingClientRect();
    const progress = Math.min(Math.max(-rect.top / Math.max(rect.height, 1), 0), 1);
    hero.style.setProperty('--sembonia-parallax-y', `${progress * 12}vh`);
  };

  const queueHeroParallax = () => {
    if (animationFrame) return;
    animationFrame = window.requestAnimationFrame(() => {
      animationFrame = undefined;
      updateHeroParallax();
    });
  };

  const destroyLenis = () => {
    if (lenis) {
      if (window.semboniaLenis === lenis) window.semboniaLenis = undefined;
      lenis.destroy();
      lenis = undefined;
    }
  };

  const initialize = () => {
    destroyLenis();

    if (!window.semboniaMobileBaseline?.lenisDisabled && !window.Shopify?.designMode && window.Lenis) {
      lenis = new window.Lenis({
        duration: 1.2,
        easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
        // Storefront glide is enabled regardless of device motion preference.
        respectReducedMotion: false,
        smoothWheel: true,
        wheelMultiplier: 1,
        orientation: 'vertical',
        gestureOrientation: 'vertical',
        virtualScroll: ({deltaY, event}) => {
          // Reverse from the visible position, not a distant old wheel target.
          if (event.type === 'wheel' && !event.ctrlKey && lenis && !lenis.isStopped &&
              deltaY && lenis.velocity && Math.sign(deltaY) !== Math.sign(lenis.velocity)) {
            lenis.scrollTo(lenis.actualScroll, {immediate:true});
          }
          return true;
        },
        // Restore the confirmed stable mobile behaviour: browser-native finger
        // momentum, without Lenis release amplification or accelerated settling.
        syncTouch: false,
        autoRaf: true,
        // The shared lock owns overflow and explicitly stops/starts Lenis.
        autoToggle: false,
        // Collection results and fixed-body drawers change document height.
        // Read the live root scroll range instead of a cached pre-close limit.
        naiveDimensions: true,
        allowNestedScroll: true,
        stopInertiaOnNavigate: true
      });
      lenis.on('scroll', queueHeroParallax);
      window.semboniaLenis = lenis;
      window.semboniaScrollLock?.attachLenis(lenis);
    }

    updateHeroParallax();
  };

  window.addEventListener('scroll', queueHeroParallax, { passive: true });
  window.addEventListener('resize', queueHeroParallax, { passive: true });
  document.addEventListener('shopify:section:load', queueHeroParallax);
  window.addEventListener('sembonia:mobile-baseline-change', initialize);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();
